import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Text from 'src/Components/Text'
import { ProConList } from 'src/Components/List'
import Player from 'src/Components/Player/Player'
import { ExternalLinkButton } from 'src/Components'

import styles from './InstantOffer.module.scss'

const propTypes = {
  className: PropTypes.string,
  customerFirstName: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  productName: PropTypes.string.isRequired
}

const Pro = props => <ProConList.Pro color='white' {...props} />
const Con = props => <ProConList.Con color='white' {...props} />

const Heading = props => (
  <Text size='l' weight='light' align='center' {...props} />
)

const InstantOffer = ({
  className,
  customerFirstName,
  href,
  onClick,
  productName,
  ibuyerVideoType,
  ibuyerVideoEnabled,
  ibuyerVideoExternalId
}) => {
  if (ibuyerVideoEnabled) {
    return (
      <Fragment>
        <Text element='div' align='center'>
          <FormattedMessage
            id='ibuyer.instantOffer.video.header'
            defaultMessage={`{customerFirstName} has provided {productName} to help you get an instant offer on your home.`}
            values={{
              customerFirstName,
              productName: <Text.Strong>{productName}</Text.Strong>
            }}
          />
        </Text>
        <Player
          className={styles.videoPlayer}
          videoId={ibuyerVideoExternalId}
          videoType={ibuyerVideoType}
        />
        <Text element='div' align='center'>
          <FormattedMessage
            id='ibuyer.instantOffer.video.footer'
            defaultMessage="An instant offer is an alternative to selling on the open market. There's no fee or commitment when you request an instant offer."
          />
        </Text>

        <Text element='div' align='center'>
          <ExternalLinkButton
            data-qa='instantOfferButton'
            className={styles.button}
            href={href}
            onClick={onClick}
          >
            <FormattedMessage
              id='ibuyer.instantOffer.primarybutton'
              defaultMessage='Get cash offer'
            />
          </ExternalLinkButton>
        </Text>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Heading paragraph>
        <FormattedMessage
          id='ibuyer.drawer.headline'
          defaultMessage='{customerFirstName} has provided {productName} to help you with an instant offer on your home.'
          values={{
            customerFirstName,
            productName: <Text.Strong>{productName}</Text.Strong>
          }}
        />
      </Heading>
      <Text size='s' align='left'>
        <FormattedMessage
          id='ibuyer.drawer.subheadline'
          defaultMessage='An instant offer is an alternative to selling on the open market. There’s no fee or commitment when you request an instant offer.'
        />
      </Text>
      <div className={styles.lists}>
        <div className={styles.pros}>
          <Heading>
            <FormattedMessage id='pro' defaultMessage='Pros' />
          </Heading>
          <ProConList>
            <Pro>
              <FormattedMessage
                id='ibuyer.drawer.probullet1'
                defaultMessage='Sell your house faster'
              />
            </Pro>
            <Pro>
              <FormattedMessage
                id='ibuyer.drawer.probullet2'
                defaultMessage='No open houses or showings'
              />
            </Pro>
            <Pro>
              <FormattedMessage
                id='ibuyer.drawer.probullet3'
                defaultMessage='Choose your move & closing date'
              />
            </Pro>
          </ProConList>
        </div>
        <div className={styles.cons}>
          <Heading>
            <FormattedMessage id='con' defaultMessage='Cons' />
          </Heading>
          <ProConList>
            <Con>
              <FormattedMessage
                id='ibuyer.drawer.conbullet1'
                defaultMessage='Offer often lower than market value'
              />
            </Con>
            <Con>
              <FormattedMessage
                id='ibuyer.drawer.conbullet2'
                defaultMessage='Different selling fees could apply'
              />
            </Con>
            <Con>
              <FormattedMessage
                id='ibuyer.drawer.conbullet3'
                defaultMessage='Not all homes are eligible'
              />
            </Con>
          </ProConList>
        </div>
      </div>
      <Text element='div' align='center'>
        <ExternalLinkButton
          data-qa='instantOfferButton'
          className={styles.button}
          href={href}
          onClick={onClick}
        >
          <FormattedMessage
            id='ibuyer.drawer.primarybutton'
            defaultMessage='Get cash offer'
          />
        </ExternalLinkButton>
      </Text>
    </Fragment>
  )
}

InstantOffer.propTypes = propTypes

export default InstantOffer
